<template>
  <div id="recent-trade-feed-wrapper" class="summary-card">
    <div class="card-title">최근 실거래 피드</div>
    <div v-if="loading" class="loading-state"><p>불러오는 중...</p></div>
    <div v-else-if="trades.length === 0" class="loading-state"><p>거래 데이터가 없습니다.</p></div>
    <div v-else class="feed-list">
      <div
        v-for="(item, idx) in trades"
        :key="idx"
        class="feed-item"
      >
        <div class="feed-date">{{ item.dealYear }}.{{ String(item.dealMonth).padStart(2, '0') }}.{{ String(item.dealDay).padStart(2, '0') }}</div>
        <div class="feed-info">
          <span class="feed-apt">{{ item.aptNm }}</span>
          <span class="feed-area">{{ item.excluUseAr }}㎡ / {{ item.floor }}층</span>
        </div>
        <div class="feed-amount">{{ (item.dealAmount / 10000).toFixed(1) }}억</div>
        <div class="feed-gu">{{ item.umdNm }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import UtilMixin from "@/common/mixins/UtilMixin";

export default defineComponent({
  name: "RecentTradeFeed",
  mixins: [UtilMixin],
  data() {
    return {
      trades: [] as any[],
      loading: false,
    };
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await this.getApi().apt().getRecentTrades({ size: 10 });
        this.trades = res || [];
      } catch {
        this.trades = [];
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchData();
  },
});
</script>
